import type { ResolutionString } from "../../../../../public/charting_library";

export function tradingChartTimeframeToWsResolution(
  resolution: ResolutionString,
): string {
  switch (resolution) {
    case "1":
      return "1m";
    case "5":
      return "5m";
    case "15":
      return "15m";
    case "60":
      return "1h";
    case "240":
      return "4h";
    case "1D":
      return "1d";
    case "1W":
      return "1d";
    default:
      return "1m";
  }
}
